import React from 'react';
import ReactDOM from 'react-dom';
import sa from'sa-sdk-javascript';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { WxConfig } from './service/wx'

// // Create wrapper.
// const wrapper = document.createElement('html');
// wrapper.id = 'i-amp-html-wrapper';

// // Setup classes and styles.
// wrapper.className = document.documentElement.className;
// document.documentElement.className = '';
// document.documentElement.style = 'overflow-y: scroll;-webkit-overflow-scrolling: touch;';
// wrapper.style = 'display: block;overflow-y: auto;-webkit-overflow-scrolling: touch;position: fixed;top: 0;left: 0;right: 0;bottom: 0;';

// // Attach wrapper straight inside the document root.
// document.documentElement.appendChild(wrapper);

// // Reparent the body.
// const body = document.body;
// wrapper.appendChild(body);

// Object.defineProperty(document, 'body', {
//     get: () => body,
// });

let defaultConfig = {
    web_url: 'https://data.xuezhanggui.com/?project=default',
    server_url: 'https://rcvdata.xuezhanggui.com/sa?project=default'
};
let productionConfig = {
    web_url: 'https://data.xuezhanggui.com/?project=production',
    server_url: 'https://rcvdata.xuezhanggui.com/sa?project=production'
};
sa.init({
    name: 'sa',
    web_url: process.env.NODE_ENV === 'production' ? productionConfig.web_url : defaultConfig.web_url,
    server_url: process.env.NODE_ENV === 'production' ? productionConfig.server_url : defaultConfig.server_url,
    show_log: false,
    heatmap: {}
});
sa.quick('autoTrack');
WxConfig();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
